export default {
  us: {
    title: '<strong class=\'aqua\'>Así empezó todo...</strong>',
    description: 'Grupo Ilú fue nuestra primera experiencia como ' +
    'empresarios; fue una época enriquecedora ' +
    'donde nos propusimos la misión de <strong class=\'aqua\'>crear aplicaciones y sitios web </strong>' +
    'originales que cumplieran con las expectativas ' +
    'de los emprendedores emergentes en toda Venezuela.',
    time1: 'Tener un negocio propio había sido un sueño de  jóvenes universitarios hasta el 2008, cuando fundamos Grupo Ilu.',
    barraDescription: 'Cuatro años más tarde entramos a una nueva etapa, con un equipo de trabajo renovado.',
    subtitulo: 'Apök',
    section2: {
      title: 'Nos convertimos en',
      text1: 'Elegimos un nombre que rindiera honor al amor que sentimos por Venezuela. Optamos por Apök, que ' +
      '<i style="font-style: italic">en lengua pemón significa <strong>fuego.</strong></i>',
      text2: 'Cuenta la leyenda que los primeros humanos, Makunaimö y su hermano Chikö, obtuvieron el fuego al ' +
      'llevarse una rama encendida de Mutuk, el ave del fuego. <strong style="font-style: italic">¡El nombre hizo clic de inmediato!</strong>'
    },
    barraOscura: {
      frase: '…y así seguimos creciendo',
      text1: 'De tres programadores y un diseñador fuimos creciendo poco a poco, poniendo mucho empeño ' +
      'y dedicación en ayudar a los emprendedores a hacer realidad sus proyectos digitales, con la fortuna de incluso lograr traspasar las fronteras.'
    },
    difference: {
      title: '<strong class=\'difference-title w-100 float-left\'>Nos convertirnos <br/>en unos <br/>apasionados</strong>',
      text: 'Tenemos una pasión por las ideas y nos entusiasma cada vez que iniciamos un nuevo proyecto. Estamos claros de la responsabilidad y el respeto que debemos a nuestros clientes. Nos caracterizamos por la productividad, efectividad y profesionalismo en cada resultado entregado y... ¡por supuesto, por el buen humor!'
    },
    textHeader: 'NUESTRA HISTORIA',
    textFooter: 'Empezamos en el 2012 y aquí seguimos creciendo y aprendiendo',
    designer: 'Designer'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/es/about_us.js